import { SharedIcon } from 'components/SharedIcon/SharedIcon';
import { Button } from 'react-bootstrap';

interface Props {
  onBack: () => void;
}

const BackArrow = ({ onBack }: Props) => (
  <Button
    className="d-flex m-0 me-3 p-0 border-0 bg-transparent"
    onClick={onBack}
  >
    <SharedIcon iconName="arrow_back" size="md" color="light" />
  </Button>
);

export default BackArrow;
